import { IPostFrom } from '../../types/postForm';
import { TBlogPostFormActions } from './blogPostFormReducer';

/** Пропсы и обработчики для филда Заголовок */
export const useTitleField = (dispatch: IPostFrom, state: React.Dispatch<TBlogPostFormActions>) => {
  return {
    errorMessage: '',
    required: true,
    value: '',
    disabled: false,
    onChange: () => {},
  };
};
